import PropTypes from 'prop-types';
import React from 'react';
import {ButtonGroup} from 'react-bootstrap';
import {compose, getContext, pure} from 'recompose';
import CancelChangePlanButton from './ActionButtons/CancelChangePlanButton';

const ChangePlanButtonGroupPure = ({
                                     displayVertical,
                                   }) => (
  <ButtonGroup vertical={displayVertical} block={displayVertical}>
    <CancelChangePlanButton/>
  </ButtonGroup>
);

ChangePlanButtonGroupPure.propTypes = {
  displayVertical: PropTypes.bool,
};

const ChangePlanButtonGroup = compose(
  getContext(
    {
      displayVertical: PropTypes.bool,
    },
  ),
  pure,
)(ChangePlanButtonGroupPure);

ChangePlanButtonGroup.propTypes = {};

export default ChangePlanButtonGroup;